import { useState } from 'react'
import styles from './reading-chat.module.css'

type Props = {
  src: string | null | undefined
  letter: string
  muted?: boolean
  large?: boolean
}

export function ChatAvatar({ src, letter, muted = false, large = false }: Props) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const photo = src && src !== failedSrc ? src : null
  const cls = [styles.av, large ? styles.avLg : '', muted && !photo ? styles.avUser : '', photo ? styles.avPhoto : ''].filter(Boolean).join(' ')
  return (
    <span className={cls} aria-hidden="true">
      {photo ? <img src={photo} alt="" onError={() => setFailedSrc(photo)} /> : letter}
    </span>
  )
}

export function initialOf(name: string | null | undefined, fallback: string): string {
  return (name?.trim() || fallback).charAt(0).toUpperCase()
}
